module.exports = __webpack_public_path__ + "img/register_blue.5d540c2b.png";